import { Grid, Skeleton } from "@mui/material";
import React from "react";

function RecentVideoSkeleton() {
  return (
    <Grid container spacing={2} alignItems={"center"}>
      {[1, 2, 3, 4, 5, 6, 7, 8].map((item, i) => {
        return (
          <Grid item xs={12} sm={12} md={3} lg={3} key={i}>
            <Skeleton variant="rectangular" width="100%" height={200} />
            <Skeleton
              variant="rectangular"
              width="100%"
              height={20}
              sx={{ margin: "10px 0px 10px 0px" }}
            />
            <Skeleton
              variant="rectangular"
              width="100%"
              height={20}
              sx={{ margin: "10px 0px 20px 0px" }}
            />
          </Grid>
        );
      })}
    </Grid>
  );
}

export default RecentVideoSkeleton;
